import { useLazyQuery } from '@apollo/react-hooks'
import Error from '@components/Error'
import { InstructorsQueryResult } from '@interfaces/Instructor'
import { FMIStudentProfileContext } from '@layouts/Scheduling/Instructors/context'
import InstructorAvailability from '@layouts/Scheduling/Instructors/Availability'
import { GET_INSTRUCTORS_BY_PROGRAM_ID } from '@queries/getInsructorsByProgramId'
import { useRouter } from 'next/router'
import React, { useContext, useEffect, useMemo } from 'react'
import InstructorsLoader from '../InstructorsLoader'
import { initHJ } from '@utils/hotjar'
import { FMIBulkFormProvider } from '../BulkForm/Form/useFMIBulkForm'
import { FMIBulkSelectInstructorsProvider } from '../BulkForm/SelectInstructors/useSelectInstructors'

const AvailabilityWrapper: React.FC = () => {
  const router = useRouter()
  const { userProfileLoading, userProfileError, userProfile, currStudent, currProgram } = useContext(
    FMIStudentProfileContext
  )
  const [getInstructors, { error, loading, data }] = useLazyQuery<InstructorsQueryResult>(
    GET_INSTRUCTORS_BY_PROGRAM_ID,
    { fetchPolicy: 'no-cache' }
  )

  const initHJUser = () => {
    if (userProfile && currStudent) {
      initHJ()
      // @ts-ignore
      window.hj('identify', userProfile?.SFId, {
        displayLanguage: currStudent?.student?.PortalLanguage,
        languageLearning: currStudent?.LanguageLearning,
        productType: currStudent?.ProductTypes,
      })
    }
  }

  useEffect(() => {
    try {
      if (userProfile?.SFId && router.query.programId) {
        initHJUser()

        getInstructors({
          variables: {
            query: {
              StudentProfileId: userProfile?.SFId,
              ProgramId: router.query.programId,
            },
          },
        })
      }
    } catch (e) {
      console.error(e)
    }
  }, [userProfile?.SFId, router.query.programId])

  const Component = useMemo(() => {
    return userProfile && currProgram ? (
      <FMIBulkSelectInstructorsProvider>
        <FMIBulkFormProvider Program={currProgram}>
          <InstructorAvailability loading={loading} instructors={loading ? undefined : data} />
        </FMIBulkFormProvider>
      </FMIBulkSelectInstructorsProvider>
    ) : null
  }, [userProfile, loading, data, currProgram])

  return (
    <>
      {userProfileError || error ? <Error statusCode="400" /> : userProfileLoading ? <InstructorsLoader /> : Component}
    </>
  )
}

export default AvailabilityWrapper
